import angular from "angular";

// Global decorator on every <input>. Bug fix: type="number" inputs let users type 'e'/'E'/'+'
// (scientific notation) which corrupts the bound value. Decorator form (no restrict) is
// intentional so the fix applies to every number input in the app without per-markup opt-in.
angular.module('ui-common')
    .directive('input', function () {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                if (attrs.type !== 'number') {
                    return;
                }
                element.on('keydown', function (e) {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+') {
                        e.preventDefault();
                    }
                });
            }
        };
    });
